import React from 'react';

const AdSpace = ({ position }) => {
  return (
    <div className={`ad-space ${position}`}>
      <span className="ad-label">Advertisement Space ({position})</span>
      {/* Insert Google Adsense Script Here Later */}
    </div>
  );
};

export default AdSpace;